$.browser.chrome=/chrome/.test(navigator.userAgent.toLowerCase()),$.browser.chrome&&($("html").addClass("chrome"),$.browser.safari=!1),$.browser.safari&&$("html").addClass("safari"),$.browser.msie&&$("html").addClass("ie"),$.browser.msedge&&$("html").addClass("edge"),$.browser.mozilla&&$.browser.version>"2"&&$("html").addClass("firefox");var os=["iphone","ipad","windows","mac","linux"],match=navigator.appVersion.toLowerCase().match(new RegExp(os.join("|")));match&&$("html").addClass(match[0]);var isDesktop=window.matchMedia("only screen and (min-width : 1224px)"),isMobile=window.matchMedia("only screen and (max-width : 1024px) and (-webkit-min-device-pixel-ratio: 1)"),isMobilePortraitOnly=window.matchMedia("only screen and (max-width : 41.6875em) and (orientation : portrait)"),isMobileLandscapeOnly=window.matchMedia("only screen and (max-width : 41.6875em) and (orientation : landscape)"),isTablet=window.matchMedia("only screen and (max-width : 1024px)"),isTabletPortraitOnly=window.matchMedia("only screen and (min-width : 768px) and (max-width : 1024px) and (orientation : portrait)"),isTabletLandscapeOnly=window.matchMedia("only screen and (min-width : 768px) and (max-width : 1024px) and (orientation : landscape)");
/**
 * Video Rebuilding
 */
$(window).load(function() {
  $('#ssw-fave-list-widget').show();
    var timerblock = "<div class='product-bfcm-countdown'><span class='ambient-pink'>Get 20% off </span><br>Use promo code: <strong>newyear</strong><br><span class='countdown-timer'></span></div>";
  	$('.product .product-options').prepend(timerblock);
  
	!function(a){"use strict";"function"==typeof define&&define.amd?define(["jquery"],a):a(jQuery)}(function(a){"use strict";function b(a){if(a instanceof Date)return a;if(String(a).match(g))return String(a).match(/^[0-9]*$/)&&(a=Number(a)),String(a).match(/\-/)&&(a=String(a).replace(/\-/g,"/")),new Date(a);throw new Error("Couldn't cast `"+a+"` to a date object.")}function c(a){var b=a.toString().replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1");return new RegExp(b)}function d(a){return function(b){var d=b.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);if(d)for(var f=0,g=d.length;f<g;++f){var h=d[f].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),j=c(h[0]),k=h[1]||"",l=h[3]||"",m=null;h=h[2],i.hasOwnProperty(h)&&(m=i[h],m=Number(a[m])),null!==m&&("!"===k&&(m=e(l,m)),""===k&&m<10&&(m="0"+m.toString()),b=b.replace(j,m.toString()))}return b=b.replace(/%%/,"%")}}function e(a,b){var c="s",d="";return a&&(a=a.replace(/(:|;|\s)/gi,"").split(/\,/),1===a.length?c=a[0]:(d=a[0],c=a[1])),Math.abs(b)>1?c:d}var f=[],g=[],h={precision:100,elapse:!1,defer:!1};g.push(/^[0-9]*$/.source),g.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),g.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),g=new RegExp(g.join("|"));var i={Y:"years",m:"months",n:"daysToMonth",d:"daysToWeek",w:"weeks",W:"weeksToMonth",H:"hours",M:"minutes",S:"seconds",D:"totalDays",I:"totalHours",N:"totalMinutes",T:"totalSeconds"},j=function(b,c,d){this.el=b,this.$el=a(b),this.interval=null,this.offset={},this.options=a.extend({},h),this.instanceNumber=f.length,f.push(this),this.$el.data("countdown-instance",this.instanceNumber),d&&("function"==typeof d?(this.$el.on("update.countdown",d),this.$el.on("stoped.countdown",d),this.$el.on("finish.countdown",d)):this.options=a.extend({},h,d)),this.setFinalDate(c),this.options.defer===!1&&this.start()};a.extend(j.prototype,{start:function(){null!==this.interval&&clearInterval(this.interval);var a=this;this.update(),this.interval=setInterval(function(){a.update.call(a)},this.options.precision)},stop:function(){clearInterval(this.interval),this.interval=null,this.dispatchEvent("stoped")},toggle:function(){this.interval?this.stop():this.start()},pause:function(){this.stop()},resume:function(){this.start()},remove:function(){this.stop.call(this),f[this.instanceNumber]=null,delete this.$el.data().countdownInstance},setFinalDate:function(a){this.finalDate=b(a)},update:function(){if(0===this.$el.closest("html").length)return void this.remove();var b,c=void 0!==a._data(this.el,"events"),d=new Date;b=this.finalDate.getTime()-d.getTime(),b=Math.ceil(b/1e3),b=!this.options.elapse&&b<0?0:Math.abs(b),this.totalSecsLeft!==b&&c&&(this.totalSecsLeft=b,this.elapsed=d>=this.finalDate,this.offset={seconds:this.totalSecsLeft%60,minutes:Math.floor(this.totalSecsLeft/60)%60,hours:Math.floor(this.totalSecsLeft/60/60)%24,days:Math.floor(this.totalSecsLeft/60/60/24)%7,daysToWeek:Math.floor(this.totalSecsLeft/60/60/24)%7,daysToMonth:Math.floor(this.totalSecsLeft/60/60/24%30.4368),weeks:Math.floor(this.totalSecsLeft/60/60/24/7),weeksToMonth:Math.floor(this.totalSecsLeft/60/60/24/7)%4,months:Math.floor(this.totalSecsLeft/60/60/24/30.4368),years:Math.abs(this.finalDate.getFullYear()-d.getFullYear()),totalDays:Math.floor(this.totalSecsLeft/60/60/24),totalHours:Math.floor(this.totalSecsLeft/60/60),totalMinutes:Math.floor(this.totalSecsLeft/60),totalSeconds:this.totalSecsLeft},this.options.elapse||0!==this.totalSecsLeft?this.dispatchEvent("update"):(this.stop(),this.dispatchEvent("finish")))},dispatchEvent:function(b){var c=a.Event(b+".countdown");c.finalDate=this.finalDate,c.elapsed=this.elapsed,c.offset=a.extend({},this.offset),c.strftime=d(this.offset),this.$el.trigger(c)}}),a.fn.countdown=function(){var b=Array.prototype.slice.call(arguments,0);return this.each(function(){var c=a(this).data("countdown-instance");if(void 0!==c){var d=f[c],e=b[0];j.prototype.hasOwnProperty(e)?d[e].apply(d,b.slice(1)):null===String(e).match(/^[$A-Z_][0-9A-Z_$]*$/i)?(d.setFinalDate.call(d,e),d.start()):a.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi,e))}else new j(this,b[0],b[1])})}});
	var finaltime = '2019/01/01 07:00:00'; // 10am on the 20th
    $('.countdown-timer').countdown(finaltime)
    .on('update.countdown', function(event) {
      var format = '%D day %H hr %M min %S sec';
      if(event.offset.totalDays === 0) {
        format = '%H hr %M min %S sec';
      }
      $(this).html(event.strftime('<span class="ambient-pink">Sale Ends::</span> '+format+'<br><span style="font-size: 0.8em;color:#fff;">*except modular orders</span>'));
    })
    .on('finish.countdown', function(event) {
      $(this).html('Sale Ended!');
      $('.product-bfcm-countdown').remove();
    });
  
     $('.banner-countdown-timer').countdown(finaltime)
    .on('update.countdown', function(event) {
      var format = '%D day %H hr %M min %S sec';
      if(event.offset.totalDays === 0) {
        format = '%H hr %M min %S sec';
      }
      $(this).html(event.strftime('<span class="ambient-pink">Last Xmas orders:</span> '+format+'<br><span style="font-size: 0.8em;color:#fff;">*except modular orders</span>'));
    })
    .on('finish.countdown', function(event) {
        $(this).html('Sale Ended!');
      $('.product-bfcm-countdown').remove();
    });
 
  // END BF / CM JS
               
$.each($(".video-player"),function(){var a=$(this).data("type");"youtube"==a?($(this).append(videoThumbYT($(this).data("id"))),$(this).on("click",videoIframeYT)):"vimeo"==a?($(this).append(videoThumbV($(this).data("id"))),$(this).on("click",videoIframeV)):"facebook"==a&&($(this).append(videoThumbFB($(this).data("id"))),$(this).on("click",videoIframeFB))}),$.each($('iframe[src*="youtube.com"]'),function(){var a=$('<div class="video-player" data-type="youtube">'),i=$(this).attr("src");i=i.substr(i.lastIndexOf("/")+1),a.attr("data-id",i),a.html(videoThumbYT(i)),a.on("click",videoIframeYT);var e=$('<div class="video-container">');e.append(a),$(this).replaceWith(e)}),$.each($('iframe[src*="vimeo.com"]'),function(){var a=$('<div class="video-player" data-type="vimeo">'),i=$(this).attr("src");i=i.substr(i.lastIndexOf("/")+1),a.attr("data-id",i),videoThumbV(i,function(i){a.html(i)}),a.on("click",videoIframeV);var e=$('<div class="video-container">');e.append(a),$(this).replaceWith(e)}),$.each($('iframe[src*="facebook.com/plugins/video"]'),function(){$(this).addClass("facebook-iframe"),$(this).wrap('<div class="video-container">').wrap('<div class="video-player" data-type="facebook">')});
});

function videoThumbYT(a){return'<img class="youtube-thumb" src="//i.ytimg.com/vi/'+a+'/default.jpg?autoplay=1"><div class="play-button"></div>'}function videoIframeYT(){var a=$("<iframe>");a.attr("src","//www.youtube.com/embed/"+$(this).attr("data-id")+"?autoplay=1&autohide=2&border=0&wmode=opaque&enablejsapi=1&controls=1&showinfo=0&rel=0"),a.attr("frameborder","0"),a.addClass("youtube-iframe"),$(this).empty(),$(this).append(a)}function videoThumbV(a,e){$.ajax({type:"GET",url:"//vimeo.com/api/v2/video/"+a+".json",jsonp:"callback",dataType:"jsonp",success:function(a){var t=a[0].thumbnail_large;e('<img class="vimeo-thumb" src="'+t+'"><div class="play-button"></div>')}})}function videoIframeV(){var a=$("<iframe>");a.attr("src","//player.vimeo.com/video/"+$(this).attr("data-id")+"?autoplay=1&autohide=2&border=0&wmode=opaque&enablejsapi=1&controls=0&showinfo=0&title=0&byline=0"),a.attr("frameborder","0"),a.addClass("vimeo-iframe"),$(this).empty(),$(this).append(a)}function fbvideoID(a){return/2F(\d+)%/g.exec(a)[1]}function videoThumbFB(a){return'<img class="facebook-thumb" src="//graph.facebook.com/'+a+'/picture"><div class="play-button"></div>'}function videoIframeFB(){var a=$("<iframe>");a.attr("src","//www.facebook.com/video/embed?video_id="+$(this).attr("data-id")+"&amp;autoplay=1"),a.attr("frameborder","0"),a.addClass("facebook-iframe"),$(this).empty(),$(this).append(a)}

  /**
 * Sticky Menu
 */
  
// function stickyMenu() {
//   var distanceY = window.pageYOffset || document.documentElement.scrollTop,
//       shrinkOn = 60,
//       header = $("body header.header");
//   if (distanceY > shrinkOn) {
//     $(header).addClass("smaller");
//   } else {
//     if($(header).hasClass("smaller")){
//       $(header).removeClass("smaller");
//     }
//   }
//   if ($("body.index").length) {
//     var shrinkOn = 280;
//     if (distanceY > shrinkOn) {
//       $(header).addClass("menuBackground");
//     } else {
//       if($(header).hasClass("menuBackground")){
//         $(header).removeClass("menuBackground");
//       }
//     }
//   }
// }

// $(window).scroll(function(){
//   if(isDesktop.matches || isTabletLandscapeOnly.matches){
//     stickyMenu();
//   }
// });

/* image swap on main menu and is not mobile */

$(document).ready(function(){
 
if(isDesktop.matches || isTabletLandscapeOnly.matches){

    var $image = $('.menu-image');
    
    $('.header-nav-links li.is-nested').hover(function() {
      var $defaultSource = $(this).find('ul.dropdown-level-1:first ul li:first');
      var defaultImgSource = $defaultSource.data('image');
      $defaultSource.addClass("hover");
      $image.attr('src', defaultImgSource);

  	});
    
    $('.dropdown-sectioned ul li').hover(function() {
      var newSource = $(this).data('image');
      
      $('.dropdown-sectioned ul li').each(function(i) {
      	if($(this).hasClass("hover")){
          $(this).removeClass("hover");
        }
      });
      $image.attr('src', newSource);
    });
  
}

});
  
/* mobile cart slideout */
var $miniCart = $('#cart_over');
var $cartLink = $('.mini-cart');
var $siteContent = $('.top-header-container, .main-content, footer');

function cartOpen(){
  
  event.preventDefault();
  if ($miniCart.hasClass("cart-slide-in")) {
    $miniCart.addClass("cart-slide-out");
    $siteContent.addClass("content-slide-in");
  } else if ($miniCart.hasClass("cart-slide-out")) {
    $miniCart.removeClass('cart-slide-out');
    $miniCart.addClass("cart-slide-in");
  } else {
    $miniCart.addClass("cart-slide-in");
  }

  if ($siteContent.hasClass("content-slide-out")) {
    $siteContent.addClass("content-slide-in");
    $siteContent.removeClass("content-slide-out");
  } else if ($siteContent.hasClass("content-slide-in")) {
    $siteContent.addClass("content-slide-out");
    $siteContent.removeClass("content-slide-in");
  } else {
    $siteContent.addClass("content-slide-out");
  }

}

function cartClose(){
  $('#cart_over').removeClass('shownxxx'); 
  $('#cart_over').addClass('hiddenxxx');
  //clode the lateral panel
  if ($miniCart.hasClass("cart-slide-in")) {
    $miniCart.removeClass('cart-slide-in');
    $miniCart.addClass('cart-slide-out');
    $siteContent.removeClass("content-slide-out");
    $siteContent.addClass("content-slide-in");      
    event.preventDefault();
  }
}

$cartLink.on('click', function(event){
  if(isMobile.matches || isTabletPortraitOnly.matches){
    cartOpen();
  }
});

$('#cart_close').on('click', function(event){
  cartClose(); 
});

//bind to resize
$(window).resize( function() {
  $cartLink.on('click', function(event){
    if(isMobile.matches || isTabletPortraitOnly.matches){
      cartOpen();
    }
  });
  $('#cart_close').on('click', function(event){
    cartClose(); 
  });
});

//check for the orientation event and bind accordingly
window.addEventListener("orientationchange", function() {
  $cartLink.on('click', function(event){
    if(isMobile.matches || isTabletPortraitOnly.matches){
      cartOpen();
    }
  });
  $('#cart_close').on('click', function(event){
    cartClose(); 
  });
}, false);

/* switch country */
function switchCountry() {
  if(document.getElementById('country').value) {
    window.location.href = document.getElementById('country').value;
  }
}
 
// Facebook sharing for hovering product
function fbShare(url, title, description, image) {
  var winHeight = "350";
  var winWidth = "520";
  var winTop = (screen.height / 2) - (winHeight / 2);
  var winLeft = (screen.width / 2) - (winWidth / 2);
  window.open('http://www.facebook.com/sharer.php?s=100&p[title]=' + title + '&p[summary]=' + description + '&p[url]=' + url + '&p[images][0]=' + image, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
}

$('.shareIt').on('click', function(event){
  var url = $(this).data('url');
  var title = $(this).data('title');
  var description = $(this).data('description');
  var image = $(this).data('image');
  fbShare(url, title, description, image);
});


(function ($) {
  if (navigator.userAgent.indexOf('Safari') && !navigator.userAgent.indexOf('Chrome')) {
	$('body').css('font-family', 'Times New Roman');  
  }
  
  $(".breadcrumb li span, .product-title, .product-item-title, .cart-items .item-title a").each(function() {
    var text = $(this).text();
    
    text = text.replace(/(\w+\s)+-\s/g, "");
    $(this).text(text);
    $(this).show();
  });
    
  
  isMobile = false; //initiate as false
// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;
  
 
  
  
  
  //////////////////////////////////////
  // COUNTRY DETECTION AND REDIRECTS
  //////////////////////////////////////
  
  
  countries = ['AU','CA','CL','JP','NZ','SG','US','RU','KR'];
  eu_countries = ['FR','IT','ES','DE','SE','AT','BE','BG','HR','CY','CZ','DK','EE','FI','GR'];
  
  country_select = null;

  /*
  $.getJSON("https://remote.ambientlounge.co.uk/ip-detect/index.php?callback=?",

  function(json) {
	//alert("in eu");
    // if in a EU country pass to UK site
    if ($.inArray(json.code, eu_countries) > -1 ) {
      // show country UK
      var country_select = 'c_UK';
      var country_image = 'eu';
      var country_link = 'http://www.ambientlounge.co.uk';
      var country_short = 'UK';
      
      var message = "Looks like you're in " + json.country + " <span class='flag flag-" + country_image +"'></span> No problem. All European customers can buy from this Ambient Lounge "+ country_short +" site";
      
      // set top bat details
      $(".country-select .message").html(message);
      $(".country-select").show(); 
    }
    
    if ($.inArray(json.code, countries) > -1 ) {
      //alert(json.code);
      if(json.code  == 'AU'){
        // if country is Australia
        var country_select = 'c_AU';
        var country_image = 'au';
        var country_link = 'https://www.ambientlounge.com.au';
        var country_short = 'AUS';
        var showCountry = true; 
      } else if(json.code  == 'CA'){
        // if country is CA
        var country_select = 'c_CA';
        var country_image = 'ca';
        var country_link = 'https://www.ambientlounge.com';
        var country_short = 'CA';
        var showCountry = true; 
      } else if(json.code  == 'CL'){
        // if country is Chile
        var country_select = 'c_CL';
        var country_image = 'cl';
        var country_link = 'https://www.ambientlounge.cl';
        var country_short = 'CL';
        var showCountry = true;
      } else if(json.code  == 'GB'){
        // if country is UK
        var country_select = 'c_UK';
        var country_image = 'gb';
        var country_link = 'https://www.ambientlounge.co.uk';
        var country_short = 'UK';
        var showCountry = false;
      } else if(json.code  == 'JP'){
        // if country is JP
        var country_select = 'c_JP';
        var country_image = 'jp';
        var country_link = 'https://www.ambientlounge.co.jp';
        var country_short = 'JP';
        var showCountry = true;
      } else if(json.code  == 'NZ'){
        // if country is NZ
        var country_select = 'c_NZ';
        var country_image = 'nz';
        var country_link = 'https://www.ambientlounge.co.nz';
        var country_short = 'NZ';
        var showCountry = true;
      } else if(json.code  == 'SG'){
        // if country is SG
        var country_select = 'c_SG';
        var country_image = 'sg';
        var country_link = 'https://www.ambientlounge.sg';
        var country_short = 'SG';
        var showCountry = true;
      } else if(json.code  == 'RU'){
        // if country is RU
        var country_select = 'c_RU';
        var country_image = 'ru';
        var country_link = 'https://www.ambientlounge.ru';
        var country_short = 'RU';
        var showCountry = true;
      } else if(json.code  == 'KR'){
        // if country is KR
        var country_select = 'c_KR';
        var country_image = 'kr';
        var country_link = 'https://www.ambientlounge.kr';
        var country_short = 'KR';
        var showCountry = true; 
      } else if(json.code  == 'US'){
        // if country is US
        var country_select = 'c_US';
        var country_image = 'us';
        var country_link = 'https://www.ambientlounge.com'; 
        var country_short = 'US';
        var showCountry = true;
      }

      var message = "Looks like you're in " + json.country + " <span class='flag flag-" + country_image +"'></span> Take me to the Ambient Lounge "+ country_short +" site <a href='"+ country_link +"' class='button country_found_link'>Visit Site</a>";
      
      // set top bat details
      $(".country-select .message").html(message);
      $(".country_found_short").html(country_short);
      if(showCountry == true) {
        $(".country-select").show(); 
      } else {
      	$(".country-select").hide(); 
      }
    }

  });
  */

  
  
  
  var methods = {
    settings: {
      shopCurrency: window.shop.shopCurrency,
      moneyFormat: window.shop.moneyFormat
    },

    init: function() {
      this.find('.item-quantity input').on('change', $.proxy(methods.updateLine, this));
      this.find('#cart-note').on('change', $.proxy(methods.updateCartNote, this));
    },

    /**
     * @param event
     */
    updateLine: function(event) {
      var elem = $(event.currentTarget),
          moneyFormat = methods.settings['moneyFormat'],
          shopCurrency = methods.settings['shopCurrency'],
          variantId = parseInt(elem.attr('data-variant-id')),
          newCurrency = $('[name=currencies]').val() || shopCurrency,
          newQuantity = elem.val();
      

      if (parseInt(newQuantity) === 0) {
        // If we have no products, we don't want to trigger an Ajax call otherwise it would remove it from the cart.
        // Therefore we set it back to 1 and return
        elem.val('1');
        return;
      }

      Shopify.changeItem(variantId, newQuantity, function(result) {
        // We need to update the price on the line AND on the total result
        var line = $('.cart-items tr[data-variant-id=' + variantId + ']'),
            total = $('.cart-total .money');

        // Extract the line in the response
        for (var i = 0 ; i != result['items'].length ; ++i) {
          var currentLine = result['items'][i];

          if (currentLine['variant_id'] === variantId) {
            line.find('.item-line-price .money')
              .html(Shopify.formatMoney(currentLine['line_price'], moneyFormat))
              .attr('data-currency', shopCurrency)
              .removeAttr('data-currency-' + newCurrency.toLowerCase());

            break;
          }
        }

        // We need to update the currency in order to trigger a conversion
        total.html(Shopify.formatMoney(result['total_price'], moneyFormat))
          .attr('data-currency', shopCurrency)
          .removeAttr('data-currency-' + newCurrency.toLowerCase());

        Currency.convertAll(shopCurrency, $('[name=currencies]').val());
      });
    },

    /**
     * @param event
     */
    updateCartNote: function(event) {
      var elem = $(event.currentTarget);
      Shopify.updateCartNote(elem.val(), function(cart) {});
    }
  };

  $.fn.cartAjaxify = function(options) {
    return methods.init.call(this, options);
  };
}(jQuery));
/**
 * Plugin to automatically "featurify" an image
 */

(function ($) {
  var methods = {
    /**
     * @type {Object}
     */
    settings: {
      enableZoom: true, // Allow to enable zoom whenever we hover on an image
      listSelector: '.thumbnail-list', // List that holds the link to thumbnails
      magnify: 1,
      triggerEvent: "click" // Event that trigger the change
    },

    init: function() {
      // Enable the zoom on hover (by using the large image)
      if (methods.settings.enableZoom && isMobile == false) {
        this.find('.image-featured').each(function (index, item) {
          var element = $(item);

          if (element.attr('data-fancybox-type') === 'image') {
            element.zoom({
              url: element.attr('href'),
              magnify: methods.settings.magnify
            });
          }
        });
      }

      // We attach a listener for each image in the thumbnail list to change the featured image
      $(methods.settings.listSelector).find('a').on(methods.settings.triggerEvent, $.proxy(methods.updateFeatured, this));
    },

    /**
     * @param event
     */
    updateFeatured: function(event) {
      var target = $(event.currentTarget),
          active = this.find('li.active'),
          imageId = target.attr('data-id');

      // If the settings is to change picture on click, we do not want to trigger the lightbox, so we need to
      // stop propagation, UNLESS the image the user is clicking is the same
      if (methods.settings.triggerEvent === 'click' && target.attr('data-id') !== active.attr('data-image-id')) {
        event.stopPropagation();
        event.preventDefault();
      }

      // We need to switch the image
      this.find('li').removeClass('active')
        .filter('[data-image-id=' + imageId + ']').addClass('active');
    }
  };

  $.fn.featurify = function(options) {
    return methods.init.call(this, options);
  };
}(jQuery));
/**
 * Plugin to automatically "ajaxify" the product
 */

(function ($) {
  var methods = {
    /**
     * @type {Object}
     */
    settings: {
      addToCartLabel: "Kjøp nå",
      addingToCartLabel: "Legger til i handlekurven...",
      addedToCartLabel: "Produktet ble lagt til!"
    },

    init: function() {
      // Replace the labels if we are in the "pre-order" template
      if (window.shop.template === 'product.pre-order') {
        methods.settings = {
          addToCartLabel: "Forhåndsbestill",
          addingToCartLabel: "Forhåndsbestill",
          addedToCartLabel: "Produktet ble forhåndsbestilt!"
        };
      }

      this.on('click', $.proxy(methods.addProduct, this));

      Shopify.onError = $.proxy(methods.error, this);
      Shopify.onItemAdded = $.proxy(methods.added, this);
      Shopify.onCartUpdate = $.proxy(methods.cartUpdated, this);
    },

    /**
     * @param event
     */
    addProduct: function(event) {
      // First step, we change the content to the "addingToCartLabel"
      this.text(methods.settings['addingToCartLabel']);
      this.attr('disabled', 'disabled');
      this.addClass('loading');

      Shopify.addItemFromForm('add-to-cart-form');

      return false;
    },

    /**
     * @param response
     */
    added: function(response) {
      this.text(methods.settings['addedToCartLabel']);
      this.removeClass('loading').addClass('success');

      $('.added-to-cart-links').show();

      // We also need to update the cart info
      Shopify.getCart();

      setTimeout($.proxy(methods.revertDefaults, this), 2500);
    },

    /**
     * @param response
     */
    error: function(response) {
      this.text(response.responseJSON.description);
      this.removeClass('loading').addClass('error');

      setTimeout($.proxy(methods.revertDefaults, this), 2500);
    },

    /**
     *
     */
    revertDefaults: function() {
      this.text(methods.settings['addToCartLabel']);
      this.removeClass('error loading success');
      this.removeAttr('disabled');
    },

    /**
     * @param response
     */
    cartUpdated: function(response) {
      $('.cart-item-count').text(response['item_count']);
    }
  };

  $.fn.productAjaxify = function(options) {
    return methods.init.call(this, options);
  };
}(jQuery));


/**
 * JQuery Pick (used to display related products)
 */
(function( $ ){
  $.fn.pick = function(count) {

    var howMany = count || 4;

    // Picking random numbers without repeating.
    var index_array = [];
    var original_obj_size = this.size();
    for (var i=0; i<original_obj_size; i++) {
      index_array.push(i);
    }
    //+ Jonas Raoni Soares Silva
    //@ http://jsfromhell.com/array/shuffle [rev. #1]
    var shuffle = function(v) {
      for (var j, x, i = v.length; i; j = parseInt(Math.random() * i), x = v[--i], v[i] = v[j], v[j] = x);
      return v;
    };
    var new_index_array = shuffle(index_array).slice(0,howMany);

    // Ditching unpicked elements and removing those from the returned set.
    return this.each(function(i) {
      if ($.inArray(i,new_index_array) === -1) {
        $(this).remove();
      }
    }).filter(function() {
      if (this.parentNode === null) {
        return false;
      }
      else {
        return true;
      }
    });

  };
})( jQuery );
/**
 * Callback that automatically updates the variant
 */

window.maestroooProduct = function(options) {
  var variant = options['variant'],
      context = $('[data-product-id="' + options['productId'] + '"]'),
      offers = context.find('.product-offer'),
      inventory = context.find('.variant-inventory-quantity'),
      optionsContainer = context.find('.product-options'),
      labelsContainer = offers.find('.product-labels'),
      pricesContainer = offers.find('.product-prices');

  // We remove all the things that may change
  inventory.hide();
  pricesContainer.find('.price, .sale-percent, .on-sale-label').remove().end();
  labelsContainer.find('.product-label').show();
  labelsContainer.find('.sold-out-label, .unavailable-label').hide();
  optionsContainer.find('.button-add-to-cart-container').show();
  optionsContainer.find('.back-in-stock').hide();

  // There are a lot of things we need to change... so let's start!
  if (variant) {
    // This one allows to check the right color if swatch are used
    for (var i = 0 ; i < variant.options.length ; i++) {
      var radioButtonValue = variant.options[i].replace(/([ !"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~])/g,'\\\\$1');
      var radioButton = context.find('.swatch[data-option-index="' + i + '"]').find(':radio[value="' + radioButtonValue + '"]');

      if (radioButton.size()) {
        radioButton.closest('.swatch-element').addClass('active');
        radioButton.get(0).checked = true;
      }
    }

    if (!variant['available']) {
      // If variant only is not available... we show the sold out label, and hide the "Add to Cart" button
      labelsContainer.find('.sold-out-label').css('display', 'inline-block');
      optionsContainer.find('.button-add-to-cart-container').hide();
      optionsContainer.find('.back-in-stock').show();
    } else {
      var price = Shopify.formatMoney(variant['price'], options.moneyFormat),
          compareAtPrice = Shopify.formatMoney(variant['compare_at_price'], options['moneyFormat']);

      if (variant['compare_at_price'] > variant['price']) {
        var percentDrop = (variant['compare_at_price'] - variant['price']) / variant['compare_at_price'] * 100;
    
        pricesContainer.prepend('<span class="new-price price money">' + price + '</span>')
          .prepend('<span class="old-price price money">' + compareAtPrice + '</span>');

        if (percentDrop > 0) {
          // pricesContainer.append('<span class="sale-percent mobile">Spar ' + Math.round(percentDrop) + '%</span>');
          // pricesContainer.find('.saving_text .save_price').append(Math.round(percentDrop));
        }
      } else {
        pricesContainer.prepend('<span class="price money">' + price + '</span>');
      }
    }

    // We need to update the quantity
    if (inventory.length > 0 && variant['inventory_management'] !== null) {
      inventory.find('.count').text(variant['inventory_quantity']).end().show();
    }

    // If the variant has a featured image associated with it, we need to modify the featured image
    if (variant['featured_image']) {
      $('.product-showcase .featured-image-list li').removeClass('active')
        .filter('[data-image-id=' + variant['featured_image']['id'] + ']')
        .addClass('active');
    }
  } else {
    // This is an unavailable variant, so we need to hide the "add to cart" button, and show the "unavailable" label
    optionsContainer.find('.button-add-to-cart-container').hide();
    labelsContainer.find('.product-label').hide().end().find('.unavailable-label').css('display', 'inline-block');
  }

  Currency.convertAll(options['shopCurrency'], $('[name=currencies]').val());
};
var router = new RouterRouter();

/**
 * ----------------------------------------------------------------------------------------------------
 * ACCOUNT ADDRESSES ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('account/addresses', function() {
  /**
   * -------------------------
   * INIT ADDRESS SELECTOR
   * -------------------------
   */

  new Shopify.CountryProvinceSelector('address_country_new', 'address_province_new', {hideElement: 'address-province-container-new'});
});
/**
 * ----------------------------------------------------------------------------------------------------
 * ACCOUNT LOGIN ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('account/login', function() {
  var switchToReset = function() {
    $('.login-form, .recover-password-form').toggle();
    $('.page-title').html("Gjenopprett passordet ditt");
  };

  // When we submit a reset password, Shopify redirects to the login page, but with the "#recover" hash
  if (window.location.hash === '#recover') {
    switchToReset();
  }

  $('.forgot-password-link').on('click', function() {
    switchToReset();
  });
});
/**
 * ----------------------------------------------------------------------------------------------------
 * CODE EXECUTED FOR EACH ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('*all', function() {
  // Is used to eliminate 300ms delay on iOS
  FastClick.attach(document.body);

  if ($('html').hasClass('ie8')) {
    $('.fancybox.search-toggle').fancybox({
      minWidth: 400,
      topRatio: 0.3,
      wrapCSS: 'mega-search',
      afterShow: function () {
        $('#search-autocomplete').focus();
      }
    });
  } else {
    $('.fancybox.search-toggle').fancybox({
      minWidth: 400,
      topRatio: 0.3,
      wrapCSS: 'mega-search',
      afterShow: function() {
        $('#search-autocomplete').focus();
      },
      helpers : {
        overlay : {
          css : {
            'background' : 'rgba(0, 0, 0, 0.92)'
          }
        }
      }
    });
  }

  /**
   * -------------------------
   * MENU ON MOBILE
   * -------------------------
   */

  $('.header-mobile-nav .search-link').on('click', function() {
    $(this).next('.tab-content').find('input').focus();
  });

  $('.header-mobile-nav .mobile-nav-tabs > li a').on('click', function() {
    $(this).parent().siblings().removeClass('active').end().toggleClass('active');
  });

  $('.header-mobile-nav .see-more').on('click', function() {
    var elem = $(this),
        text = elem.html();

    elem.html(text === '<i class="icon-plus"></i>' ? '<i class="icon-minus"></i>' : '<i class="icon-plus"></i>');

    elem.closest('.dropdown').toggleClass('open');

    return false;
  });

  if (Modernizr.touch) {
    $('.header-desktop-nav .header-nav-links .is-nested > a, .header-desktop-nav .header-nav-links .is-sub-nested > a').on('click', function(event) {
      event.preventDefault();
    });
  }

  /**
   * -------------------------
   * AUTO-COMPLETION
   * -------------------------
   */
  
    $('#search-autocomplete').awesomecomplete({
      resultLimit: 50,
      typingDelay: 50,
      suggestionListClass: 'awesomecomplete',

      dataMethod: function(term, event, done) {
        $.ajax({
          url: '/search',
          dataType: 'json',
          data: {
            type: 'product',
            q: term + '*', // We automatically add wildcard for partial matching
            view: 'json'
          }
        }).then(function(data) {
          done(data);
        });
      },

      sortFunction: function() {
        return 0;
      },

      renderFunction: function(result, term) {
        if (result['results_count'] !== undefined) {
          return '<a class="ac-results-count" href="' + result['url'] + '">' + "Se alle resultater"
            + ' (' + result['results_count'] + ')' + '</a>';
        }

        return '<a href="' + result['url'] + '"><img class="ac-product-image" src="' + result['thumbnail'] + '">'
          + '<div class="ac-product-info"><span class="ac-product-title">' + result['title'] + '</span>'
          + '<span class="ac-price-min">' + "Starter på" + ' ' + result['price_min'] + '</span></div></a>';
      },

      onComplete: function(dataItem) {
        location.href = dataItem['url'];
      }
    });
  

  /**
   * -------------------------
   * AUTOMATIC CURRENCY CONVERSION
   * -------------------------
   */

  

  /**
   * -------------------------
   * QUICK SHOP
   * -------------------------
   */

  

  /**
   * -------------------------
   * BACK TO TOP BUTTON
   * -------------------------
   */

  
    var backToTopOffset = 300,
        backToTopDuration = 500;

    $(window).on('scroll', function() {
      if ($(this).scrollTop() > backToTopOffset) {
        $('#back-to-top').fadeIn(backToTopDuration);
      }
      else {
        $('#back-to-top').fadeOut(backToTopDuration);
      }
    });

    $('#back-to-top').off('click.smoothscroll').on('click', function(e) {
      e.preventDefault();
      $('html, body').animate( { scrollTop: 0 }, backToTopDuration);

      return false;
    });
  

});
/**
 * ----------------------------------------------------------------------------------------------------
 * COLLECTION ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('cart', function() {
  var cart = $('#cart');

  /**
   * -------------------------
   * AJAXIFY THE CART
   * -------------------------
   */

  cart.cartAjaxify();

  /**
   * -------------------------
   * TERMS AND CONDITIONS CHECKBOX
   * -------------------------
   */

  

  /**
   * -------------------------
   * SHIPPING ESTIMATOR
   * -------------------------
   */

  
});
/**
 * ----------------------------------------------------------------------------------------------------
 * COLLECTION ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('collections/*type', function() {
  
  /**
   * -------------------------
   * COLLECTION DESCRIPTIONS
   * -------------------------
   */
  
  var collection_magic_container = $('.collection-magic');
  var magic_count = collection_magic_container.children('p').length;
  var deviceWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
  
  if(magic_count == 2) {
    if(isDesktop.matches || isTablet.matches){
      collection_magic_container.children('p:nth-child(1)').show(); 
      collection_magic_container.children('p:nth-child(2)').hide(); 
    } else {
      collection_magic_container.children('p:nth-child(1)').hide();
      collection_magic_container.children('p:nth-child(2)').show(); 
    }
  } else {
   	collection_magic_container.children('p:nth-child(1)').show();  
  }
  
  //if (isDesktop) {
  
  /**
   * -------------------------
   * COLLECTION HOVER SECTIONS
   * -------------------------
   */
  
  function resizeBgImgContainers() {
    $('.collection-hover a').each(function() {
      var $a = $(this);
      var img = new Image();
      img.onload = function() {
        $a.height(img.height * $a.width() / img.width / 2 - 1);
      };
      img.src = $(this).data('image'); 
      var imageHeight = $a.height();
      $(this).css('height',imageHeight);        
    });
  }
  resizeBgImgContainers();
  $(window).on('resize', resizeBgImgContainers).trigger('resize');
  
  $('.collection-hover a').on("mouseenter touchstart", function(event) {
    $(this).find('.collection-list-hover-desc').stop().fadeIn(1000);
  });
  $('.collection-hover a').on("mouseleave touchend", function(event) {
    $(this).find('.collection-list-hover-desc').stop().fadeOut(5000);
  });
  
  /**
   * -------------------------
   * SORT BY
   * -------------------------
   */

    Shopify.queryParams = {};

    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');

        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }

    $('#sort-by').val(Shopify.queryParams['sort_by'] || window.shop.collectionDefaultSortBy || 'manual')
      .on('change', function() {
        Shopify.queryParams.sort_by = $(this).val();
        location.search = decodeURIComponent($.param(Shopify.queryParams));
      });

    $('.styled-select.filters select').on('change', function(event) {
      window.location.href = $(event.currentTarget).find(':selected').val();
    });

  /**
   * -------------------------
   * PAGINATION MODE
   * -------------------------
   */

  
});
/**
 * ----------------------------------------------------------------------------------------------------
 * INDEX ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('', function() {
  
  /**
   * -------------------------
   * COUNTDOWN
   * -------------------------
   */
  
  
  
  	var product_code = "newyear";
    var countdown_timer_status = "false";
  
  	
  
  	if(countdown_timer_status == "true"){
      var timerblock = "<div class='product-bfcm-countdown'><span style='color: #fffefe;'>"+product_offer+" </span><br>"+product_use_code+" <strong>newyear</strong></div>";
    }
    $('.product .product-options').prepend(timerblock);

    !function(a){"use strict";"function"==typeof define&&define.amd?define(["jquery"],a):a(jQuery)}(function(a){"use strict";function b(a){if(a instanceof Date)return a;if(String(a).match(g))return String(a).match(/^[0-9]*$/)&&(a=Number(a)),String(a).match(/\-/)&&(a=String(a).replace(/\-/g,"/")),new Date(a);throw new Error("Couldn't cast `"+a+"` to a date object.")}function c(a){var b=a.toString().replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1");return new RegExp(b)}function d(a){return function(b){var d=b.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);if(d)for(var f=0,g=d.length;f<g;++f){var h=d[f].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),j=c(h[0]),k=h[1]||"",l=h[3]||"",m=null;h=h[2],i.hasOwnProperty(h)&&(m=i[h],m=Number(a[m])),null!==m&&("!"===k&&(m=e(l,m)),""===k&&m<10&&(m="0"+m.toString()),b=b.replace(j,m.toString()))}return b=b.replace(/%%/,"%")}}function e(a,b){var c="s",d="";return a&&(a=a.replace(/(:|;|\s)/gi,"").split(/\,/),1===a.length?c=a[0]:(d=a[0],c=a[1])),Math.abs(b)>1?c:d}var f=[],g=[],h={precision:100,elapse:!1,defer:!1};g.push(/^[0-9]*$/.source),g.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),g.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),g=new RegExp(g.join("|"));var i={Y:"years",m:"months",n:"daysToMonth",d:"daysToWeek",w:"weeks",W:"weeksToMonth",H:"hours",M:"minutes",S:"seconds",D:"totalDays",I:"totalHours",N:"totalMinutes",T:"totalSeconds"},j=function(b,c,d){this.el=b,this.$el=a(b),this.interval=null,this.offset={},this.options=a.extend({},h),this.instanceNumber=f.length,f.push(this),this.$el.data("countdown-instance",this.instanceNumber),d&&("function"==typeof d?(this.$el.on("update.countdown",d),this.$el.on("stoped.countdown",d),this.$el.on("finish.countdown",d)):this.options=a.extend({},h,d)),this.setFinalDate(c),this.options.defer===!1&&this.start()};a.extend(j.prototype,{start:function(){null!==this.interval&&clearInterval(this.interval);var a=this;this.update(),this.interval=setInterval(function(){a.update.call(a)},this.options.precision)},stop:function(){clearInterval(this.interval),this.interval=null,this.dispatchEvent("stoped")},toggle:function(){this.interval?this.stop():this.start()},pause:function(){this.stop()},resume:function(){this.start()},remove:function(){this.stop.call(this),f[this.instanceNumber]=null,delete this.$el.data().countdownInstance},setFinalDate:function(a){this.finalDate=b(a)},update:function(){if(0===this.$el.closest("html").length)return void this.remove();var b,c=void 0!==a._data(this.el,"events"),d=new Date;b=this.finalDate.getTime()-d.getTime(),b=Math.ceil(b/1e3),b=!this.options.elapse&&b<0?0:Math.abs(b),this.totalSecsLeft!==b&&c&&(this.totalSecsLeft=b,this.elapsed=d>=this.finalDate,this.offset={seconds:this.totalSecsLeft%60,minutes:Math.floor(this.totalSecsLeft/60)%60,hours:Math.floor(this.totalSecsLeft/60/60)%24,days:Math.floor(this.totalSecsLeft/60/60/24)%7,daysToWeek:Math.floor(this.totalSecsLeft/60/60/24)%7,daysToMonth:Math.floor(this.totalSecsLeft/60/60/24%30.4368),weeks:Math.floor(this.totalSecsLeft/60/60/24/7),weeksToMonth:Math.floor(this.totalSecsLeft/60/60/24/7)%4,months:Math.floor(this.totalSecsLeft/60/60/24/30.4368),years:Math.abs(this.finalDate.getFullYear()-d.getFullYear()),totalDays:Math.floor(this.totalSecsLeft/60/60/24),totalHours:Math.floor(this.totalSecsLeft/60/60),totalMinutes:Math.floor(this.totalSecsLeft/60),totalSeconds:this.totalSecsLeft},this.options.elapse||0!==this.totalSecsLeft?this.dispatchEvent("update"):(this.stop(),this.dispatchEvent("finish")))},dispatchEvent:function(b){var c=a.Event(b+".countdown");c.finalDate=this.finalDate,c.elapsed=this.elapsed,c.offset=a.extend({},this.offset),c.strftime=d(this.offset),this.$el.trigger(c)}}),a.fn.countdown=function(){var b=Array.prototype.slice.call(arguments,0);return this.each(function(){var c=a(this).data("countdown-instance");if(void 0!==c){var d=f[c],e=b[0];j.prototype.hasOwnProperty(e)?d[e].apply(d,b.slice(1)):null===String(e).match(/^[$A-Z_][0-9A-Z_$]*$/i)?(d.setFinalDate.call(d,e),d.start()):a.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi,e))}else new j(this,b[0],b[1])})}});
  	var finaltime = "2019/01/01 07:00:00"; 
    
    $('.countdown-timer').countdown(finaltime)
    .on('update.countdown', function(event) {
      var format = timer_format_1;
      if(event.offset.totalDays === 0) {
        format = timer_format_2;
      }
      $(this).html(event.strftime('<span style="color: #ed2088">'+season_offer_end+':</span> '+format+'<br><span style="font-size: 16px">'+order_terms+'</span>'));
    })
    .on('finish.countdown', function(event) {
      $(this).html(sale_ended_text);
      $('.product-bfcm-countdown').remove();
    });

    $('.countdown-timer').countdown(finaltime)
    .on('update.countdown', function(event) {
      var format = timer_format_1;
      if(event.offset.totalDays === 0) {
        format = timer_format_2;
      }
      if(countdown_timer_status != "false"){
        $(this).html(event.strftime('<span style="color: #ed2088">'+last_orders+'</span> '+format+'<br><span style="font-size: 16px">'+order_terms+'</span>'));
      }
    })
    .on('finish.countdown', function(event) {
      $(this).html(sale_ended_text);
      $('.product-bfcm-countdown').remove();
    });
 
  
  
  /**
   * -------------------------
   * SLIDER
   * -------------------------
   */

  
    $(window).ready(function() {
      $('.flexslider').flexslider({
        animation: "slide",
        useCSS: true,
        smoothHeight: true,
        prevText: '',
        nextText: '',
        controlsContainer: '.flex-controls',
        controlNav: false,
        slideshow: true,
        slideshowSpeed: "6000",
        randomize: false
      });
    });
  

  /**
   * -------------------------
   * INSTAGRAM
   * -------------------------
   */

  
    

    

    
      var feed = new Instafeed({
        get: 'user',
        userId: 266454510,
        accessToken: "6636153616.1677ed0.040e555940634bdb9c169d3a74927c50",
        sortBy: 'most-recent',
        limit: 6,
        resolution: 'low_resolution',
        template: '<div class="picture-wrapper"><a href="{{link}}" target="_blank"><div class="overlay"></div><img src="{{image}}"/></a></div>'
      });
    

    feed.run();

  

});
/**
 * ----------------------------------------------------------------------------------------------------
 * INDEX ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('pages/instagram-feed', function() {
  /**
   * -------------------------
   * INSTAGRAM
   * -------------------------
   */

  
    

    

    
       var feed = new Instafeed({
         get: 'user',
         userId: 266454510,
         accessToken: "6636153616.1677ed0.040e555940634bdb9c169d3a74927c50",
         sortBy: 'most-recent',
         limit: 40,
         resolution: 'low_resolution',
         template: '<div class="picture-wrapper"><a href="{{link}}" target="_blank"><div class="overlay"></div><img src="{{image}}"/></a></div>'
       });
    

    feed.run();

  
});
/**
 * ----------------------------------------------------------------------------------------------------
 * PRODUCT QUICK SHOP ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

var productQuickShopRoute = function() {
  // We do this only on Quick Shop to avoid the fancybox to open for the quick shop, otherwise it would be
  // a popup inside the popup ^^.
  $('.image-featured').on('click', function() {
    return false;
  });
};
/**
 * ----------------------------------------------------------------------------------------------------
 * PRODUCT ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

var productRoute = function() {
  
  /**
   * -------------------------
   * COUNTDOWN
   * -------------------------
   */
  
  
  
  	var product_code = "newyear";
    var countdown_timer_status = "false";
  
  	
  
  	if(countdown_timer_status == "true"){
      var timerblock = "<div class='product-bfcm-countdown'><span style='color: #fffefe;'>"+product_offer+" </span><br>"+product_use_code+" <strong>newyear</strong></div>";
    }
    $('.product .product-options').prepend(timerblock);

    !function(a){"use strict";"function"==typeof define&&define.amd?define(["jquery"],a):a(jQuery)}(function(a){"use strict";function b(a){if(a instanceof Date)return a;if(String(a).match(g))return String(a).match(/^[0-9]*$/)&&(a=Number(a)),String(a).match(/\-/)&&(a=String(a).replace(/\-/g,"/")),new Date(a);throw new Error("Couldn't cast `"+a+"` to a date object.")}function c(a){var b=a.toString().replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1");return new RegExp(b)}function d(a){return function(b){var d=b.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);if(d)for(var f=0,g=d.length;f<g;++f){var h=d[f].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),j=c(h[0]),k=h[1]||"",l=h[3]||"",m=null;h=h[2],i.hasOwnProperty(h)&&(m=i[h],m=Number(a[m])),null!==m&&("!"===k&&(m=e(l,m)),""===k&&m<10&&(m="0"+m.toString()),b=b.replace(j,m.toString()))}return b=b.replace(/%%/,"%")}}function e(a,b){var c="s",d="";return a&&(a=a.replace(/(:|;|\s)/gi,"").split(/\,/),1===a.length?c=a[0]:(d=a[0],c=a[1])),Math.abs(b)>1?c:d}var f=[],g=[],h={precision:100,elapse:!1,defer:!1};g.push(/^[0-9]*$/.source),g.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),g.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),g=new RegExp(g.join("|"));var i={Y:"years",m:"months",n:"daysToMonth",d:"daysToWeek",w:"weeks",W:"weeksToMonth",H:"hours",M:"minutes",S:"seconds",D:"totalDays",I:"totalHours",N:"totalMinutes",T:"totalSeconds"},j=function(b,c,d){this.el=b,this.$el=a(b),this.interval=null,this.offset={},this.options=a.extend({},h),this.instanceNumber=f.length,f.push(this),this.$el.data("countdown-instance",this.instanceNumber),d&&("function"==typeof d?(this.$el.on("update.countdown",d),this.$el.on("stoped.countdown",d),this.$el.on("finish.countdown",d)):this.options=a.extend({},h,d)),this.setFinalDate(c),this.options.defer===!1&&this.start()};a.extend(j.prototype,{start:function(){null!==this.interval&&clearInterval(this.interval);var a=this;this.update(),this.interval=setInterval(function(){a.update.call(a)},this.options.precision)},stop:function(){clearInterval(this.interval),this.interval=null,this.dispatchEvent("stoped")},toggle:function(){this.interval?this.stop():this.start()},pause:function(){this.stop()},resume:function(){this.start()},remove:function(){this.stop.call(this),f[this.instanceNumber]=null,delete this.$el.data().countdownInstance},setFinalDate:function(a){this.finalDate=b(a)},update:function(){if(0===this.$el.closest("html").length)return void this.remove();var b,c=void 0!==a._data(this.el,"events"),d=new Date;b=this.finalDate.getTime()-d.getTime(),b=Math.ceil(b/1e3),b=!this.options.elapse&&b<0?0:Math.abs(b),this.totalSecsLeft!==b&&c&&(this.totalSecsLeft=b,this.elapsed=d>=this.finalDate,this.offset={seconds:this.totalSecsLeft%60,minutes:Math.floor(this.totalSecsLeft/60)%60,hours:Math.floor(this.totalSecsLeft/60/60)%24,days:Math.floor(this.totalSecsLeft/60/60/24)%7,daysToWeek:Math.floor(this.totalSecsLeft/60/60/24)%7,daysToMonth:Math.floor(this.totalSecsLeft/60/60/24%30.4368),weeks:Math.floor(this.totalSecsLeft/60/60/24/7),weeksToMonth:Math.floor(this.totalSecsLeft/60/60/24/7)%4,months:Math.floor(this.totalSecsLeft/60/60/24/30.4368),years:Math.abs(this.finalDate.getFullYear()-d.getFullYear()),totalDays:Math.floor(this.totalSecsLeft/60/60/24),totalHours:Math.floor(this.totalSecsLeft/60/60),totalMinutes:Math.floor(this.totalSecsLeft/60),totalSeconds:this.totalSecsLeft},this.options.elapse||0!==this.totalSecsLeft?this.dispatchEvent("update"):(this.stop(),this.dispatchEvent("finish")))},dispatchEvent:function(b){var c=a.Event(b+".countdown");c.finalDate=this.finalDate,c.elapsed=this.elapsed,c.offset=a.extend({},this.offset),c.strftime=d(this.offset),this.$el.trigger(c)}}),a.fn.countdown=function(){var b=Array.prototype.slice.call(arguments,0);return this.each(function(){var c=a(this).data("countdown-instance");if(void 0!==c){var d=f[c],e=b[0];j.prototype.hasOwnProperty(e)?d[e].apply(d,b.slice(1)):null===String(e).match(/^[$A-Z_][0-9A-Z_$]*$/i)?(d.setFinalDate.call(d,e),d.start()):a.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi,e))}else new j(this,b[0],b[1])})}});
  	var finaltime = "2019/01/01 07:00:00"; 
    
    $('.countdown-timer').countdown(finaltime)
    .on('update.countdown', function(event) {
      var format = timer_format_1;
      if(event.offset.totalDays === 0) {
        format = timer_format_2;
      }
      $(this).html(event.strftime('<span style="color: #ed2088">'+season_offer_end+':</span> '+format+'<br><span style="font-size: 16px">'+order_terms+'</span>'));
    })
    .on('finish.countdown', function(event) {
      $(this).html(sale_ended_text);
      $('.product-bfcm-countdown').remove();
    });

    $('.countdown-timer').countdown(finaltime)
    .on('update.countdown', function(event) {
      var format = timer_format_1;
      if(event.offset.totalDays === 0) {
        format = timer_format_2;
      }
      if(countdown_timer_status != "false"){
        $(this).html(event.strftime('<span style="color: #ed2088">'+last_orders+'</span> '+format+'<br><span style="font-size: 16px">'+order_terms+'</span>'));
      }
    })
    .on('finish.countdown', function(event) {
      $(this).html(sale_ended_text);
      $('.product-bfcm-countdown').remove();
    });
 
  
                     
  
  /**
   * -------------------------
   * ACTIVATE THINGS LIKE ZOOM AND UPDATE THE FEATURED IMAGE
   * -------------------------
   */
  $('.featured-image-list').featurify();

  /**
   * -------------------------
   * BACK IN STOCK
   * -------------------------
   */

  
    $('.back-in-stock-form').submit(function(event) {
      event.preventDefault();

      var email = $(event.target).find('input').val(),
          variantId = $('[name=id]').val();

      BISPopover.create(email, variantId).then(function(data) {
        var msg = '';

        $('.back-in-stock .alert-box').hide();

        if (data.status == 'OK') {
          msg = data.message; // just show the success message
          $('.back-in-stock .alert-success').show().find('.message').text(msg);
          $('.back-in-stock-form').hide();
        } else { // it was an error
          for (var k in data.errors) {  // collect all the error messages into a string
            msg += data.errors[k].join();
          }

          $('.back-in-stock .alert-error').show().find('.message').text(msg);
        }
      });
    });
  

  /**
   * -------------------------
   * COLOR SWATCH
   * -------------------------
   */

  
    $('.swatch-element').on('click', function() {
      var optionIndex = $(this).parents('.swatch').attr('data-option-index');
      var optionValue = $(this).children('[type="radio"]').val();
      var context = $(this).closest('form');

      $('.single-option-selector', context).eq(optionIndex).find('option').filter(function() {
        return $(this).text() == optionValue
      }).parent().val(optionValue).trigger('change');
    });
  

  /**
   * -------------------------
   * AJAX ADD TO CART
   * -------------------------
   */

  
    $('.button-add-to-cart').productAjaxify();
  

  /**
   * -------------------------
   * RELATED PRODUCTS
   * -------------------------
  */

  
    
    var relatedProducts = $('.related-products li');
    relatedProducts.pick(12);
    relatedProducts.show();

    $('.related-products li:nth-child(6n+1)').addClass('first');
  

    /**
   * -------------------------
   * FANCYBOX (LIGHTBOX)
   * -------------------------
   */

  $('.image-showcase.fancybox').fancybox({
    openEffect  : 'fade',
    closeEffect : 'fade',
    nextEffect  : 'fade',
    prevEffect  : 'fade',
    wrapCSS     : 'image-showcase-fancybox',
    topRatio    : 0.2,
    padding     : 0,
    margin      : [20, 60, 150, 60],
    helpers : {
      overlay : {
        css : {
          'background' : 'rgba(0, 0, 0, 0.9)'
        }
      },
      title: null
    },
    afterLoad: function() {
      var list = $('#product-showcase-links');

      if (!list.length) {
        list = $('<ul id="product-showcase-links">');
        console.log('thm'+this.group.length);
        for (var i = 0; i < this.group.length; i++) {
          var thumbnail = this.group[i].element.attr('data-thumbnail'),
              html = '<li data-index="' + i + '"><div class="overlay"></div><img src="' + thumbnail + '"></li>';

          $(html).click(function() {
            $.fancybox.jumpto($(this).data('index'));
          }).appendTo(list);
        }

        list.appendTo('body');
      }

      list.find('li').removeClass('active').eq(this.index).addClass('active');
    },
    beforeClose: function() {
      $('#product-showcase-links').remove();
    }
  });
  
  $(document).ready(function() {
    
    var originalTabs = $('.originalTabs').html();
    var windowWidth = 0;
    var swapSpeed = 300;
    var scrollSpeed = 200;

    function clearTabs() {
      $('.originalTabs').html(originalTabs);
    }

    //clearTabs();
    //desktopTabs(); 

    function desktopTabs() {
      clearTabs();

      // cretate tabs for desktop
      var headers = $("#tab_description h6");
	  var state = "block";
      
      $('#tab_description h6').each(function(i) {
        $(this).nextUntil("h6").andSelf().wrapAll('<div class="tab" id="tab-' + i + '"/>');
      });

      if(headers.length > 1){
        state = "block";
      } else {
        state = "none";
      }
      
      for (var i = 0; i < headers.length; i++) {
        $('.tabs').append('<li class="" style="display: '+ state +'"><a href="#tab-' + i + '">' + headers[i].innerHTML + '</a></li>');
      } 

      $('ul.tabs').each(function() {
        var active, content, links = $(this).find('a');
        var listitem = $(this).find('li');
        active = listitem.first().addClass('active');
        content = $(active.attr('href'));
        $('.tab').hide();
        $(this).find('a').click(function(e) {
          $('.tab').hide();
          $('ul.tabs li').removeClass('active');

          content.hide();
          active = $(this);
          content = $($(this).attr('href'));
          active.parent().addClass('active');
          content.show();
          return false;
        });
      });

      headers.remove(); // remove headers from description  
      $('#tab-0').show(); // show the first tab

      $('#tab_description').show();
    }

    function mobileTabs() {
      clearTabs();

      //alert("loaded mobile");

      var headers = $("#tab_description h6");

      $(headers).each(function(i) {
        $(this).append('<a href="#accordion_' + (i + 1) + '" id="accordion_' + (i + 1) + '"></a>');
        //$(this).nextUntil("h6").andSelf().wrapAll('<div class="aTab" id="tab-'+i+'"/>');
        $(this).on('click tap', function() {
          tabClick($(this));
        });
      });

      $('#tab_description h6').first().addClass("active");
      $('#tab_description h6').first().nextUntil("h6").show();

      $('#tab_description').show();
    }

    var tabClick = function(x) {
      //alert("clicked");
      var accordionContent = $('#tab_description p, #tab_description ul, #tab_description table, #tab_description div');

      //$('#tab_description h6').removeClass("active");
      if (!$(x).hasClass("active")) {
        $(x).addClass("active");
        $('#tab_description h6').removeClass("active");
        $(accordionContent).slideUp(swapSpeed);
        $('#tab_description div > div').show();
        $(x).addClass("active");
        $(x).nextUntil('h6').slideDown(swapSpeed).promise().then(function() {
          scrollToTab($(x));
        });
      } else {
         $('#tab_description h6').removeClass("active");
         if ($(x).next("p").css('display') == 'none') {
          $('#tab_description div > div').show();
          $(x).nextUntil('h6').slideDown(swapSpeed).promise().then(function() {
            scrollToTab($(x));
          });
        } else {
          $(accordionContent).slideUp(swapSpeed);
        }
      }


      return false;

    }

    function scrollToTab(x) {
      $("html, body").animate({
        scrollTop: $(x).offset().top - 10
      }, scrollSpeed);
    }

    //load default
    //$(function() {

      if (isMobileLandscapeOnly.matches || isTabletLandscapeOnly.matches) {
          //alert("Mobile / Tablet (Portrait)");
          desktopTabs();
          //$('#tab_description h6').on("click, tap", tabClick);

          //console.log(originalTabs);
        } else if (isMobilePortraitOnly.matches || isTabletPortraitOnly.matches) {
          //alert("Mobile / Tablet (Portrait)");
          mobileTabs();
          //$('#tab_description h6').on("click, tap", tabClick);

        } else if (isDesktop) {
          //alert("Desktop");
          desktopTabs();
        }

    //});

    //bind to resize
    /*$(window).on("orientationchange resize", function() {

      if (windowWidth != $(window).width()) {

        if (isMobileLandscapeOnly.matches || isTabletLandscapeOnly.matches) {
          desktopTabs();
          $('#tab_description h6').on("click tap", tabClick);

        } else if (isMobilePortraitOnly.matches || isTabletPortraitOnly.matches) {
          mobileTabs();
          $('#tab_description h6').on("click tap", tabClick);

        } else if (isDesktop) {
          desktopTabs();
        }

        windowWidth = $(window).width();
        delete windowWidth;

      }

    });*/

  });
  
}
  
router.route('products/*type', productRoute);
router.route('collections/*collection/products/*type', productRoute);
router.route('products_preview', productRoute);
/**
 * ----------------------------------------------------------------------------------------------------
 * SEARCH ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('search', function() {
  /**
   * -------------------------
   * PAGINATION MODE
   * -------------------------
   */

  
});
     /*
 $(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("Du må godta vilkårene for salg for å sjekke ut.");
        return false;
      }
    });
  });        
       */ 
       
        
          
  var slideWrapper = $(".main-slider"),
    iframes = slideWrapper.find('.embed-player'),
    lazyImages = slideWrapper.find('.slide-image'),
    lazyCounter = 0;

// POST commands to YouTube or Vimeo API
function postMessageToPlayer(player, command){
  if (player == null || command == null) return;
  player.contentWindow.postMessage(JSON.stringify(command), "*");
}

// When the slide is changing
function playPauseVideo(slick, control){
  var currentSlide, slideType, startTime, player, video;

  currentSlide = slick.find(".slick-current");
  slideType = currentSlide.attr("class").split(" ")[1];
  player = currentSlide.find("object").get(0);
  startTime = currentSlide.data("video-start");

  if (slideType === "vimeo") {
    switch (control) {
      case "play":
        if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
          currentSlide.addClass('started');
          postMessageToPlayer(player, {
            "method": "setCurrentTime",
            "value" : startTime
          });
        }
        postMessageToPlayer(player, {
          "method": "play",
          "value" : 1
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          "method": "pause",
          "value": 1
        });
        break;
    }
  } else if (slideType === "youtube") {
    switch (control) {
      case "play":
        postMessageToPlayer(player, {
          "event": "command",
          "func": "mute"
        });
        postMessageToPlayer(player, {
          "event": "command",
          "func": "playVideo"
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          "event": "command",
          "func": "pauseVideo"
        });
        break;
    }
  } else if (slideType === "video") {
    video = currentSlide.children("video").get(0);
    if (video != null) {
      if (control === "play"){
        video.play();
      } else {
        video.pause();
      }
    }
  }
}

// Resize player
function resizePlayer(iframes, ratio) {
  if (!iframes[0]) return;
  var win = $(".main-slider"),
      width = win.width(),
      playerWidth,
      height = win.height(),
      playerHeight,
      ratio = ratio || 16/9;

  iframes.each(function(){
    var current = $(this);
    if (width / ratio < height) {
      playerWidth = Math.ceil(height * ratio);
      current.width(playerWidth).height(height).css({
        left: (width - playerWidth) / 2,
         top: 0
        });
    } else {
      playerHeight = Math.ceil(width / ratio);
      current.width(width).height(playerHeight).css({
        left: 0,
        top: (height - playerHeight) / 2
      });
    }
  });
}

// DOM Read
//$(function() {
//$(window).load(function() {
//$(document).ready(function() {
window.onload = function(){
  // Initialize
  slideWrapper.on("init", function(slick){
    slick = $(slick.currentTarget);
    setTimeout(function(){
      playPauseVideo(slick,"play");
    }, 1000);
    resizePlayer(iframes, 16/9);
  });
  slideWrapper.on("beforeChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"pause");
  });
  slideWrapper.on("afterChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"play");
  });
  slideWrapper.on("lazyLoaded", function(event, slick, image, imageSource) {
    lazyCounter++;
    if (lazyCounter === lazyImages.length){
      lazyImages.addClass('show');
      // slideWrapper.slick("slickPlay");
    }
  });

  //start the slider
  /*
  slideWrapper.slick({
    // fade:true,
    autoplaySpeed:4000,
    lazyLoad:"progressive",
    speed:600,
    arrows:false,
    dots:true,
    cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)"
  });
  */
}

// Resize event
$(window).on("resize.slickVideoPlayer", function(){  
  resizePlayer(iframes, 16/9);
});
        
        
            $(document).ready(function(){
      $('#tracktorContainer').addClass('container');
    });

     $(document).ready(function () {        
         // setInterval(function(){   console.clear();  }, 0);
      });  
 
        
      $(document).ready(function(){
        $(".fancyblock").fancybox({  openEffect: "none",  closeEffect: "none"
        });
        
        $(".product-gallery .zoom").hover(function(){  $(this).addClass('transition');
        }, function(){  $(this).removeClass('transition');
        });
      });
 
      $(document).ready(function(){
        $('a[href^="http"]').not('a[href^=""]').attr('target', '_blank');
      }); 
    
      $(document).ready(function(){
        $('#login_recovery').on('click', function(){
          var urlfb = ""+"/account/login#recover";
          window.location.href = urlfb;
        });
      });    
   
        $(document).ready(function () {
          $("#section_collapse .tablinks").on("click",function (event) {
            event.preventDefault();
            
            if($(".product-page").length>0){ return false;}

            $('#section_collapse .tablinks').removeClass("active");
            $(this).addClass("active");

            $("#section_collapse .tabcontent").css("display","none");
            var idd=$(this).attr("data");
            $("#section_collapse #"+idd).css("display","block");

            console.log(idd);
            $('html, body').animate({
              scrollTop: $("#section_collapse #"+idd).offset().top-145
            }, 1);
            return false;
          });
        });
        
        
$(document).ready(function () {

  $(".redirecttohome").click(function(){
  console.log(111);
  });
var url1 = location.hash;
var hash = url1.substring(url1.indexOf('#')+1);
//console.log('url1');        
//console.log(hash);       
});      
        
  //lazy load      
///codepen.io/chriscoyier/pen/MMXXjK
  /////codepen.io/imagekit_io/pen/MBNwKB
  document.addEventListener("DOMContentLoaded", function() {
  var lazyloadImages = document.querySelectorAll("img.lazy");    
  var lazyloadThrottleTimeout;
  
  function lazyload () {
    if(lazyloadThrottleTimeout) {
      clearTimeout(lazyloadThrottleTimeout);
    }    
    
    lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function(img) {
            if(img.offsetTop < (window.innerHeight + scrollTop)) {
              img.src = img.dataset.src;
              img.classList.remove('lazy');
            }
        });
        if(lazyloadImages.length == 0) { 
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
    }, 10);
  }
  
  document.addEventListener("scroll", lazyload);
  window.addEventListener("resize", lazyload);
  window.addEventListener("orientationChange", lazyload);
});
        

 